import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import i18n, { DEFAULT_LANG, isLang } from "./i18n";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    // Prerender vraagt pagina's op met slash ("/diensten/"); zonder 'preserve'
    // eindigt dat in een doorverwijslus en valt de pagina terug op SSR.
    trailingSlash: "preserve",
  });

  // Sync i18n with every navigation (including SSR) so the global
  // singleton is correct for whichever language the URL demands. Without
  // this, a request for /fr/... on the server can leave i18n stuck on
  // "fr" for the next request in the same isolate.
  router.subscribe("onBeforeLoad", (event) => {
    const pathname = event.toLocation.pathname;
    const first = pathname.split("/").filter(Boolean)[0];
    const lang = isLang(first) ? first : DEFAULT_LANG;
    if (i18n.language !== lang) void i18n.changeLanguage(lang);
  });

  return router;
};
